export default __webpack_public_path__ + "static/media/circle-o-close.55105f5a.svg";